import React, { FC } from 'react';
import Contact from 'src/interfaces/api/Contact';
import useContact from 'src/scenes/components/display/hooks/useContact';

interface Props {
  contactId: Contact['id'];
}

const ContactView: FC<Props> = ({ contactId }) => {
  const { contact } = useContact(contactId);

  if (!contact) {
    return null;
  }

  return (
    <>
      {contact.firstname} {contact.lastname}
    </>
  );
};

export default ContactView;
